// path: frontend/src/components/Modals/ProjectFooterActions.jsx
/**
 * Левый блок футера карточки проекта. RBAC:
 *   - capabilities.canDeleteProject — «Удалить проект» (admin/director,
 *     совпадает с ProjectService.delete). Fallback на capabilities.editRoles
 *     на случай окна деплоя между 1f и 2b-2c;
 *   - canCreateFromProject / canManageAccess — готовые булевы флаги из
 *     ProjectModal (project.permissions + capabilities).
 *
 * capabilities берёт из useAuth() — не prop-drill'ит через ProjectModal.
 */
import { Ic } from "../Icons";
import { ICONS } from "../iconsData";
import { TemplateActions } from "../Templates";
import { collectTaskPayloads } from "../../utils/templateNesting";
import { useAuth } from "../../hooks/useAuth";

export function ProjectFooterActions({
  readOnly,
  existing,
  canCreateFromProject,
  canManageAccess,
  values,
  db,
  toast,
  onDelete,
  onCopy,
  onOpenAccess,
  disabled = false,
  onSaveAsDraft = null,
  saveAsDraftDisabled = false,
}) {
  const { capabilities } = useAuth();
  const canDelete = Boolean(
    capabilities.canDeleteProject || capabilities.editRoles,
  );

  return (
    <>
      {!readOnly && existing && canDelete && (
        <button className="btn danger" onClick={onDelete} disabled={disabled}>
          <Ic d={ICONS.trash} size={14} /> Удалить проект
        </button>
      )}

      {existing && onCopy && canCreateFromProject && (
        <button
          type="button"
          className="btn ghost sm"
          onClick={() => onCopy(existing.id)}
          title="Создать новый проект на основе этого"
          disabled={disabled}
        >
          <Ic d={ICONS.copy} size={13} /> Копировать
        </button>
      )}

      {canCreateFromProject && (
        <TemplateActions
          kind="project"
          source={values}
          nested={
            existing
              ? collectTaskPayloads(
                  db.tasks.filter(
                    (t) => t.projectId === existing.id && !t.archived,
                  ),
                )
              : []
          }
          toast={toast}
          disabled={disabled || !values.name?.trim()}
        />
      )}

      {canManageAccess && (
        <button
          type="button"
          className="btn ghost sm"
          onClick={onOpenAccess}
          title="Управление доступом к проекту"
          disabled={disabled}
        >
          <Ic d={ICONS.shield} size={13} /> Доступ
        </button>
      )}

      {onSaveAsDraft && (
        <button
          type="button"
          className="btn ghost sm"
          onClick={onSaveAsDraft}
          disabled={disabled || saveAsDraftDisabled}
          title="Сохранить как личный черновик"
        >
          <Ic d={ICONS.edit} size={13} /> В черновики
        </button>
      )}
    </>
  );
}
